import type { InvoiceLineClassification } from "./types";

export function interpretOperationalUnit(name: string, explicitUnit?: string): string | undefined {
  const hay = `${name} ${explicitUnit ?? ""}`.toLowerCase();
  if (/full pan/.test(hay)) return "full pan";
  if (/half pan|1\/2 pan/.test(hay)) return "half pan";
  if (/\bdozen\b|\bdz\b/.test(hay)) return "dozen";
  if (/\bpiece|\bpc\b|\beach\b/.test(hay)) return "pieces";
  if (/\bstation/.test(hay)) return "stations";
  if (/service hour|\bhour\b/.test(hay)) return "service hours";
  if (/equipment/.test(hay)) return "equipment quantity";
  if (/rental/.test(hay)) return "rental quantity";
  if (/mile|travel fee|fee\b/.test(hay)) return "commercial line";
  return explicitUnit?.trim() || undefined;
}

export function classifyInvoiceLine(name: string, rawLine: string): {
  classification: InvoiceLineClassification;
  needsReview: boolean;
} {
  const hay = `${name} ${rawLine}`.toLowerCase();

  if (/travel fee|mile|gratuity|admin fee|processing fee/.test(hay)) {
    return { classification: "commercial_only", needsReview: false };
  }
  if (/catering service|service fee|labor fee|service commitment/.test(hay)) {
    return { classification: "service_commitment", needsReview: false };
  }
  if (/equipment|sterno|chaf|chafer|disposable dish|linen rental/.test(hay)) {
    if (/rental|third party|vendor/.test(hay)) return { classification: "rental_third_party", needsReview: true };
    return { classification: "equipment_resource", needsReview: /equipment\b/.test(hay) ? false : true };
  }
  if (/station|taco bar|grazing|buffet setup|service setup/.test(hay)) {
    return { classification: "station_setup", needsReview: /station/.test(hay) ? false : true };
  }
  if (/coffee\s*[&+]?\s*tea|tea\s*(service|station)|coffee\s*(service|station)/.test(hay)) {
    return { classification: "station_setup", needsReview: false };
  }
  if (/rental|third party|vendor supplied|outside vendor/.test(hay)) {
    return { classification: "rental_third_party", needsReview: true };
  }
  if (/pan|salad|chicken|beef|tri tip|curry|roll|cobbler|dessert|sauce|potato|brussel|wing|vegan|dinner|lunch|breakfast|coffee|tea|beverage/.test(hay)) {
    return { classification: "menu_item", needsReview: false };
  }

  return { classification: "commercial_only", needsReview: true };
}
